import { z } from "zod";
export var OAuthProviderNames;
(function (OAuthProviderNames) {
    OAuthProviderNames["Figma"] = "figma";
    OAuthProviderNames["Azure"] = "azure";
    OAuthProviderNames["Github"] = "github";
    OAuthProviderNames["Gitlab"] = "gitlab";
    OAuthProviderNames["Bitbucket"] = "bitbucket";
})(OAuthProviderNames || (OAuthProviderNames = {}));
export const OAuthProviderSchema = z.nativeEnum(OAuthProviderNames);
export const OAuthProvider = OAuthProviderSchema.enum;
